// Success case data — single source of truth used by both
// SuccessCaseSection (detailed before/after) and CasesSection (compact stat cards).
import { IMAGES } from "../constants";

// Detailed before/after cases (used by SuccessCaseSection)
export const detailedCases = [
  {
    name: "哈庫納瑪塔塔",
    link: "https://www.instagram.com/hakunamatatayilan/",
    type: "頂級非洲風包棟民宿",
    image: IMAGES.hakuna,
    before: {
      revenue: 120000,
      staff: 70000,
      staffLabel: "2位",
      utilities: 10000,
      marketing: 30000,
      marketingLabel: "行銷人員",
      outsourcing: 15000,
      outsourcingLabel: "外包行銷（SEO）",
      net: 120000 - 70000 - 10000 - 30000 - 15000, // -5000
      desc: "全新物件，一個月 3~5 單，平日幾乎空房，自己處理所有事務、行銷外包和請人管理",
    },
    after: {
      revenue: 820000,
      fee: 73000,
      commission: Math.round(820000 * 0.15), // 123,000
      staff: 70000,
      staffLabel: "2位",
      utilities: 10000,
      net: 820000 - 73000 - Math.round(820000 * 0.15) - 70000 - 10000, // 544,000
      desc: "合作後穩定衝出月營收約 82 萬，人客多接手所有行銷、客服、接單、對帳，業主僅需管理現場",
      bonusNote: "省下行銷人員 + 外包費用 NT$45,000/月",
    },
    highlight: "月營收 82 萬・增長 6 倍",
    months: "合作 2 個月見效",
  },
  {
    name: "雲岫海景渡假會館",
    type: "7 棟連棟大包棟",
    image: IMAGES.yunXiu,
    before: {
      revenue: 600000,
      simple: true,
      desc: "自營時期進單大多仰賴 OTA 平台，無法掌握客源與客戶資料，訂單來源不穩定",
    },
    after: {
      revenue: 2000000,
      desc: "人客多接手後，僅合作第 2 個月，單月進單即突破 200 萬，OTA 平台評價衝上 9.0+，成為區域熱門選擇",
      special: true,
      specialBig: "NT$ 200 萬",
      specialLabel: "合作第 2 個月・單月進單",
      specialDesc: "60 萬 → 200 萬（+400%）｜OTA 評價突破 9.0",
    },
    highlight: "單月 200 萬・第 2 個月",
    months: "合作第 2 個月見效｜OTA 評價 9.0+",
  },
  {
    name: "森山寫照",
    link: "https://www.instagram.com/sensan.inn_/",
    type: "奢華露營",
    image: IMAGES.senShan,
    before: {
      revenue: 0,
      narrative: "一片偏遠的農地，沒有經濟價值",
      desc: "合作前為偏遠農地，尚未有任何營收與經濟價值",
    },
    after: {
      revenue: 580000,
      desc: "住房率穩定在 80-90%，即將啟動第二期擴建",
      special: true,
      specialBig: "80-90%",
      specialLabel: "全案代營運・穩定住房率",
      specialDesc: "從規劃 → 建造 → 宣傳 → 營運全案由人客多執行；人客多自身經營場域出身，最懂場主痛點與挑戰；即將啟動二期擴建",
    },
    highlight: "全案代營運・住房率 80-90%",
    months: "第二期建造啟動中",
  },
  {
    name: "星夢森林劇場",
    link: "https://www.instagram.com/stardream_forest_theater/",
    type: "親子動物樂園",
    image: IMAGES.xingMeng,
    before: { revenue: 0, staff: 0, utilities: 0, net: 0, desc: "閒置農地，零收入" },
    after: {
      revenue: null,
      fee: null,
      commission: null,
      staff: null,
      utilities: null,
      net: null,
      desc: "每月 30,000+ 入園人次，Google 評論破萬",
      special: true,
      specialBig: "30,000+",
      specialLabel: "每月入園人次",
      specialDesc: "Google 評論破萬，農地成功轉型為營收亮眼的親子動物樂園",
    },
    highlight: "每月 30,000+ 入園",
    months: "農地成功轉型",
  },
];

// Compact stat cards (used by CasesSection)
export const compactCases = [
  {
    name: "哈庫納瑪塔塔",
    type: "頂級非洲風包棟民宿",
    image: IMAGES.hakuna,
    stats: [
      { label: "月營收", value: "82萬" },
      { label: "營收增長", value: "6 倍" },
      { label: "合作", value: "網紅" },
    ],
    desc: "大型網紅深度合作 × AI 方案包裝，合作 2 個月月營收從 12 萬衝上 82 萬",
  },
  {
    name: "雲岫海景渡假會館",
    type: "7 棟連棟大包棟",
    image: IMAGES.yunXiu,
    stats: [
      { label: "見效", value: "第2個月" },
      { label: "單月進單", value: "200萬" },
      { label: "成長", value: "+400%" },
    ],
    desc: "合作僅 2 個月，單月進單即從 60 萬衝上 200 萬，OTA 平台評價突破 9.0",
  },
  {
    name: "森山寫照",
    type: "奢華露營",
    image: IMAGES.senShan,
    stats: [
      { label: "住房率", value: "80-90%" },
      { label: "服務", value: "全案" },
      { label: "擴建", value: "二期中" },
    ],
    desc: "從規劃、建造、宣傳到營運全案由人客多執行；人客多自身經營場域出身，最懂場主痛點；即將啟動二期擴建",
  },
  {
    name: "星夢森林劇場",
    type: "親子動物樂園",
    image: IMAGES.xingMeng,
    stats: [
      { label: "月入園", value: "30,000+" },
      { label: "評論", value: "破萬" },
      { label: "業態", value: "農地轉型" },
    ],
    desc: "農地轉身變成每月三萬人次造訪的親子動物樂園",
  },
];
